function getTransferField(item, field) {
  let value = '';

  if (item[field] !== undefined && item[field] !== null) {
    value = item[field];
  } else {
    let upperField = field.toUpperCase();
    if (item[upperField] !== undefined && item[upperField] !== null) {
      value = item[upperField];
    }
  }

  if (value && typeof value === 'object') {
    if (value.VALUE !== undefined && value.VALUE !== null) {
      return value.VALUE;
    }

    if (Array.isArray(value) && value.length) {
      return value[0];
    }
  }

  return value || '';
}

function toNumber(value) {
  let number = parseFloat(String(value).replace(/\s+/g, '').replace(',', '.'));
  return Number.isNaN(number) ? 0 : number;
}

function formatMoney(value, currency) {
  return `${number_format(Math.round(value), undefined, undefined, ' ')} ${currency}`;
}

let selectedTransferHotelId = 0;
let selectedTransferIndex = 0;
const transferTaxRate = 0.276;

function getTransferCurrency() {
  return $('input[name="currency-type"]').eq(1).is(':checked') ? 'usd' : 'rub';
}

function getTransferGuests() {
  let adults = parseInt($('.js-adult-input').val(), 10) || 0;
  let children = parseInt($('.js-children-input').val(), 10) || 0;
  let infantCount = 0;
  let kidsCount = 0;

  $('.js-number-people__items input[name="KID_AGE[]"]').each(function () {
    let age = parseInt($(this).val(), 10) || 0;

    if (age < 2) {
      infantCount++;
    } else {
      kidsCount++;
    }
  });

  if (children > 0 && !$('.js-number-people__items input[name="KID_AGE[]"]').length) {
    kidsCount = children;
  }

  return {
    adults,
    kidsCount,
    infantCount
  };
}

function getTransferPrice(priceUsd, currency) {
  let usdValue = toNumber(priceUsd);

  if (currency === 'usd') {
    return usdValue;
  }

  return usdValue * toNumber(transfersUsdRate || 0);
}

function getSelectedHotelId() {
  return parseInt($('.js-select input[type="hidden"]').val(), 10) || 0;
}

function getTransferDateLabel() {
  return $('.js-date-placement__input').val() || '-';
}

function getTransferRoomsTax(hotel, currencyType) {
  let roomsCount = parseInt(getTransferField(hotel, 'rooms_count'), 10) || 0;
  let taxUsd = roomsCount > 50 ? 12 : 6;

  if (currencyType === 'usd') {
    return taxUsd;
  }

  return taxUsd * toNumber(transfersUsdRate || 0);
}

function buildTransferCalculatedData(transfer) {
  let guests = getTransferGuests();
  let currencyType = getTransferCurrency();
  let currencySymbol = currencyType === 'usd' ? '$' : '₽';
  let adultTotal = getTransferPrice(getTransferField(transfer, 'price_adults'), currencyType) * guests.adults;
  let kidsTotal = getTransferPrice(getTransferField(transfer, 'price_kids'), currencyType) * guests.kidsCount;
  let transferTotal = adultTotal + kidsTotal;
  let hotel = arJsHotels[getSelectedHotelId()] || {};
  let roomsTax = getTransferRoomsTax(hotel, currencyType);
  let taxTotal = transferTotal * transferTaxRate + roomsTax;

  return {
    guests,
    currencySymbol,
    adultTotal,
    kidsTotal,
    transferTotal,
    taxTotal,
    total: transferTotal + taxTotal,
    time: getTransferField(transfer, 'time'),
    previewText: getTransferField(transfer, 'PREVIEW_TEXT')
  };
}

function renderTransferSummary(hotel, transfer, transferData) {
  let itemsHtml = `<div class="price-block-info__item inner">
                    <div class="price-block-info__item-name">
                      ${transfer.NAME}
                    </div>
                    <div class="price-block-info__item-value">
                      ${getTransferDateLabel()}
                    </div>
                  </div>
                  <div class="price-block-info__item">
                    <div class="price-block-info__item-name">
                      Взрослые х ${transferData.guests.adults} чел.
                    </div>
                    <div class="price-block-info__item-value">
                      ${formatMoney(transferData.adultTotal, transferData.currencySymbol)}
                    </div>
                  </div>`;

  if (transferData.guests.kidsCount) {
    itemsHtml += `<div class="price-block-info__item">
                    <div class="price-block-info__item-name">
                      Дети 2-12 лет х ${transferData.guests.kidsCount} чел.
                    </div>
                    <div class="price-block-info__item-value">
                      ${formatMoney(transferData.kidsTotal, transferData.currencySymbol)}
                    </div>
                  </div>`;
  }

  if (transferData.guests.infantCount) {
    itemsHtml += `<div class="price-block-info__item">
                    <div class="price-block-info__item-name">
                      Дети до 2 лет х ${transferData.guests.infantCount} чел.
                    </div>
                    <div class="price-block-info__item-value">
                      бесплатно
                    </div>
                  </div>`;
  }

  itemsHtml += `<div class="price-block-info__item">
                    <div class="price-block-info__item-name">
                      Налоги
                      <span class="item-tooltip js-item-tooltip">
                        <span></span>
                        <span class="item-tooltip__text">
                          Налог рассчитывается от стоимости выбранного трансфера.
                        </span>
                        <svg>
                          <use xlink:href="/local/templates/main/img/sprite.svg#info"></use>
                        </svg>
                      </span>
                    </div>
                    <div class="price-block-info__item-value">
                      ${formatMoney(transferData.taxTotal, transferData.currencySymbol)}
                    </div>
                  </div>`;

  $('.js-transfer-summary-hotel').text(hotel.NAME || 'Отель не выбран');
  $('.js-transfer-summary-items').html(itemsHtml);
  $('.js-transfer-summary-total').text(formatMoney(transferData.total, transferData.currencySymbol));
  $('.js-transfer-summary-btn span').text('Забронировать');
}

function clearTransferSummary() {
  $('.js-transfer-summary-hotel').text('Отель не выбран');
  $('.js-transfer-summary-items').html('');
  $('.js-transfer-summary-total').text('-');
  $('.js-transfer-summary-btn span').text('Забронировать');
}

function renderTransfers() {
  let selectedHotelId = getSelectedHotelId();
  let html = '';

  if (!selectedHotelId || !arJsHotels[selectedHotelId] || !arJsHotels[selectedHotelId].transfers || !arJsHotels[selectedHotelId].transfers.length) {
    $('.js-transfer-items').html('');
    clearTransferSummary();
    selectedTransferHotelId = 0;
    selectedTransferIndex = 0;
    return;
  }

  let hotel = arJsHotels[selectedHotelId];
  let transfers = hotel.transfers;

  if (selectedTransferHotelId !== selectedHotelId) {
    selectedTransferHotelId = selectedHotelId;
    selectedTransferIndex = 0;
  }

  if (selectedTransferIndex >= transfers.length) {
    selectedTransferIndex = 0;
  }

  for (let key in transfers) {
    let transfer = transfers[key];
    let transferData = buildTransferCalculatedData(transfer);
    let isSelected = parseInt(key, 10) === selectedTransferIndex;

    html += `<div class="item-transfer${isSelected ? ' is-selected' : ''}">
                    <div class="item-transfer__row">
                      <div class="item-transfer__left">
                        <div class="item-transfer__body">
                          <div class="item-transfer__title">
                            ${transfer.NAME}
                          </div>
                          <div class="item-transfer__text">
                            ${transferData.previewText}
                          </div>
                        </div>
                      </div>
                      <div class="item-transfer__right">
                        ${transferData.time ? `<div class="item-transfer__time">
                          ≈ ${transferData.time}
                        </div>` : ''}
                        <div class="item-transfer__price">
                          <span>Взрослые (${transferData.guests.adults} чел.): ${formatMoney(transferData.adultTotal, transferData.currencySymbol)}</span>
                          ${transferData.guests.kidsCount ? `<span>Дети 2–12 лет (${transferData.guests.kidsCount} чел.): ${formatMoney(transferData.kidsTotal, transferData.currencySymbol)}</span>` : ''}
                          <span>Дети до 2 лет${transferData.guests.infantCount ? ` (${transferData.guests.infantCount} чел.)` : ''}: бесплатно</span>
                        </div>
                      </div>
                    </div>
                    <div class="item-transfer__bottom">
                      <div class="item-transfer__bottom-title">
                        ${formatMoney(transferData.transferTotal, transferData.currencySymbol)} за трансфер
                      </div>
                      <div class="item-transfer__bottom-subtitle">
                        туда-обратно
                      </div>
                      <div class="item-transfer__bottom-btn">
                        <a href="#" class="btn-gradient js-transfer-select-btn" data-transfer-index="${key}">
                          <span>${isSelected ? 'Выбрано' : 'Заказать трансфер'}</span>
                        </a>
                      </div>
                    </div>
                  </div>`;
  }

  $('.js-transfer-items').html(html);
  if (typeof lazyLoadInstance !== 'undefined' && lazyLoadInstance && typeof lazyLoadInstance.update === 'function') {
    lazyLoadInstance.update();
  }
  renderTransferSummary(hotel, transfers[selectedTransferIndex], buildTransferCalculatedData(transfers[selectedTransferIndex]));
}

$(document).on('click', '.js-select__hotel', function () {
  setTimeout(renderTransfers, 0);
});

$(document).on('click', '.js-transfer-select-btn', function (event) {
  event.preventDefault();
  selectedTransferIndex = parseInt($(this).data('transfer-index'), 10) || 0;
  renderTransfers();
});

$(document).on('change', '.js-adult-input, .js-children-input, .js-number-people__items input[name="KID_AGE[]"], .js-date-placement__input, input[name="currency-type"]', function () {
  renderTransfers();
});

$(document).ready(function () {
  renderTransfers();
});
